import { render, staticRenderFns } from "./AgeSelection.vue?vue&type=template&id=29ddaafd&scoped=true&"
import script from "./AgeSelection.vue?vue&type=script&lang=js&"
export * from "./AgeSelection.vue?vue&type=script&lang=js&"
import style0 from "./AgeSelection.vue?vue&type=style&index=0&id=29ddaafd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ddaafd",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CmsPage: require('/var/www/linza-front/linza-front-20251113114715/cms/CmsPage.vue').default})
